export const workExperience = [
  {
    position: "Software Development Engineer",
    company: "Bluecopa",
    duration: "Mar 2026 – Present · Remote, India",
    highlights: [
      "Go REST APIs with 40% p95 latency reduction and 1K+ RPS",
      "End-to-end Next.js + Go features on bi-weekly production releases"
    ]
  },
  {
    position: "Software Development Engineer (Contract)",
    company: "Discovr.ai",
    duration: "Jan 2026 – Apr 2026 · Remote, India",
    highlights: [
      "AI social analytics ingesting 50K+ posts/day across 5+ platforms",
      "LLM sentiment pipelines and real-time dashboards on GCP Cloud Run"
    ]
  },
  {
    position: "Software Engineer",
    company: "Implere Tech",
    duration: "Oct 2025 – Feb 2026 · Hyderabad, India",
    highlights: [
      "Microservices on GCP/Kubernetes with 99.9% uptime",
      "Prometheus + Grafana observability — cut alert resolution time 45%"
    ]
  },
  {
    position: "Programmer Analyst",
    company: "Cognizant Technology Solutions",
    duration: "Dec 2024 – Sep 2025 · Bangalore, India",
    highlights: [
      "Reduced API latency 45% via query optimization and caching",
      "Full-stack features for 1K+ users; promoted within 6 months"
    ]
  }
]

export const education = [
  {
    degree: "B.Tech – Computer Science & Engineering",
    institution: "KIET Group of Institutions (AKTU)",
    year: "2020 – 2024"
  },
  {
    degree: "Class XII (PCM)",
    institution: "Saraswati Vihar Sr. Sec. School",
    year: "2019"
  }
]
